module.exports = __webpack_public_path__ + "static/baby-1@2x-fc9a205b33afe1e077071bca3b61afec.jpg";